// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"54":"f9ab230f","122":"a610173c","164":"7808a4a2","318":"85d21701","544":"bffad2ad","559":"261b08a3","727":"98e0ae17","830":"65f201a1","885":"f80a7efc","980":"100b57cb"}[chunkId] + ".css";
};